import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './LogoutButton.css';

const LogoutButton = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <button type="button" onClick={handleLogout} className="logout-button" aria-label="登出">
      登出
    </button>
  );
};

export default LogoutButton;
